/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Back_TitleInputs */

const en_welcome_back_title = /** @type {(inputs: Welcome_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ICS RM Matching Week`)
};

const de_welcome_back_title = /** @type {(inputs: Welcome_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ICS RM Matching Week`)
};

/**
* | output |
* | --- |
* | "ICS RM Matching Week" |
*
* @param {Welcome_Back_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const welcome_back_title = /** @type {((inputs?: Welcome_Back_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Back_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_welcome_back_title(inputs)
	return en_welcome_back_title(inputs)
});